
import Feed from './feed'
import Tracker from './tracker/tracker.vue'
import Rightbar from './rightbar.vue'
import HintsInput from 'components/hints-input'
import $pulse from 'stores/pulse'
import $tracker from 'stores/tracker'

export default {
  components: {Feed, Tracker, Rightbar, HintsInput},
  data(){
    return {
      rb_data: undefined, // {signal_id: String, company_id?: String, contact_id?: String, tab?: String, from?: {view: String, data: ...from_data}} | null
      view: undefined, // 'track-companies' | 'track-company' | 'track-person' | 'track-topic' | 'edit-company' | 'edit-person' | 'signal'
      show_filters: true
    }
  },
  computed: {
    active: {
      get(){
        return this.$route.query.tab
      },
      set(tab){
        this.$router.push({query:{...this.$route.query, tab}})
      }
    },
    active_id(){
      switch (this.view) {
        case 'signal': 
          return this.rb_data?.signal_id
        case 'edit-company': 
          return this.rb_data?.company_id
        case 'edit-topic':
          return this.rb_data?.topic_id
        case 'edit-person': 
          return this.rb_data?.contact_id
        default: 
          return undefined
      }
    }
  },
  beforeUnmount() {
    $pulse.clearCache()
    $tracker.clearCache()
  },
  created() {    
    this.$listen('edit-company', this.editCompany)
    this.$listen('edit-person', this.editPerson)
    this.$listen('edit-topic', this.editTopic)
    
    this.$listen('track-company', this.trackCompany)
    this.$listen('track-companies', this.trackCompanies)

    this.$listen('track-person', this.trackPerson)
    this.$listen('track-topic', this.trackTopic)

    this.$listen('cancel', this.close)
    this.$listen('save', this.onSave)


    this.$listen('set-entity', (id) => {
      if (this.active === 'tracker') {
        this.active = 'feed'
        this.$listen('feed:mounted', () => {
          this.$refs.feed.setEntity(id)
        }, {once: true})
      } 
      else this.$refs.feed?.setEntity(id)
    })
    
    this.$listen('delete-tracker', (tracker) => {
      if (this.view === 'signal') {
        this.close()
      }

      const {company_id, contact_id, topic_id} = this.rb_data || {}

      if (this.active_id && [company_id, contact_id, topic_id].includes(this.active_id)) {
        this.close()
      }
      
      if (this.active === 'tracker') {
        this.$refs.tracker.loadItems()
      }
      if (this.active === 'feed') {
        this.$refs.feed.reloadEntities()
      }
    })

    this.$listen('unfavor', async (id) => {
      if (this.$refs.feed?.favorite) {
        $pulse.removeItem(id)
      }
    })

    this.$listen('disliked', async (id) => {
      $pulse.removeItem(id)
      if (this.active_id === id) this.close()
    })

    if (this.$route.query.tab !== 'tracker') {
      this.active = 'feed'
    }
    if (this.$route.query.id) {
      this.openSignal({signal_id: this.$route.query.id})
    }
  },
  methods: {
    setView(view, data) {
      this.view = view
      this.rb_data = data
    },
    openSignal(data){
      $pulse.pinItem(data.signal_id)
      this.setView('signal', data)
    },
    editCompany(data) {
      $tracker.pinItem(data.company_id)
      this.setView('edit-company', data)
    },
    trackCompany(data) {
      if (data?.from) {
        this.setView('track-company', this.createFromData(data))
      }
      else this.setView('track-company', data)
    },
    trackCompanies() {
      this.setView('track-companies')
    },
    trackTopic(data) {
      this.setView('track-topic', data?.from ? this.createFromData(data) : data)
    },
    trackPerson(data){
      if (data?.from) {
        this.setView('track-person', this.createFromData(data))
      }
      else this.setView('track-person', data)
    },
    editTopic(data) {
      $tracker.pinItem(data.topic_id)
      this.setView('edit-topic', data?.from ? this.createFromData(data) : data)
    },
    editPerson(data){
      $tracker.pinItem(data.company_id)
      if (data?.from) {
        this.setView('edit-person', this.createFromData(data))
      }
      else this.setView('edit-person', data)
    },

    createFromData(data){
      return {
        ...data,
        from: {
          view: this.view,
          data: {
            ...(typeof this.rb_data === 'object' ? this.rb_data : {}),
            ...(typeof data.from === 'object' ? data.from : {})
          },
        },
      }
    },
    close() {
      if (this.rb_data?.from) {
        const from = this.rb_data.from
        this.setView(from.view, from.data)
      }
      else this.setView(null)
    },
    onSave(){
      if (['track-person', 'track-company', 'track-companies', 'track-topic'].includes(this.view)) {
        this.close()
      }
      if (this.active === 'feed') {
        this.$refs.feed.reloadEntities()
      }
      else if (this.active === 'tracker') {
        this.$refs.tracker.loadItems()
      }
    }
  }
}
